import newsSection from "../components/newsSection/locals/ar.json";

export default {
  newsSection,
};